<template>
  <div class="col-12">
    <div
      v-if="showLogoSelection"
      class="card active-users radius-20 full-h-card mb-0"
      id="monetaryCustomers"
      style="padding-top: 110px;"
    >
      <div class="card-header border-0 bg-transparent">
        <div class="main-title row">
          <div class="col-xl-3 col-lg-4 col-md-4"></div>
          <div class="col-xl-6 col-lg-5 col-md-5">
            <div class="row">
              <div class="col-12 d-flex gap-2 align-items-center mb-32">
                <a href="javascript:;" class="back-btn" @click="goToJerseysStep">
                  <img :src="require('../images/svgs/back_arrow_icon.svg')" alt="Back Arrow Icon" />
                </a>
                <h3 class="m-0 order-flow-title">Club: {{ customer.club_name }}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="dont-forgot d-flex gap-1">
                  <img :src="require('../images/svgs/warning_sign_blue.svg')" alt="Blue Warning Sign" />
                  <p class="m-0">{{ customer.translations.do_not_forget_medal }}</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h4 class="my-2">{{ customer.translations.like_your_logo_on_jersey }}</h4>

                <div class="form-group">
                  <div v-if="customer.program_type === 'Monetary'">
                    <div class="row">
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
                        <a href="javascript:;" class="coloring" @click="showImageViewOnly">
                          {{ customer.translations.select_yes }}
                        </a>
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
                        <a href="javascript:;" class="coloring" @click="monetaryCustomers">
                          {{ customer.translations.select_no }}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <a
                          href="javascript:;"
                          class="coloring outlined-primary-btn d-flex gap-1 align-items w-100 justify-content-center py-14"
                          @click="showPlaceYourOrderView"
                        >
                          <img :src="require('../images/svgs/cross_sign.svg')" alt="Cross Sign Red" />
                          {{ customer.translations.select_no }}
                        </a>
                      </div>

                      <div class="col-12 col-md-6">
                        <a
                          href="javascript:;"
                          class="coloring primary-btn d-flex gap-1 align-items w-100 justify-content-center py-14"
                          @click="showImageViewOnly"
                        >
                          <img :src="require('../images/svgs/checkmark.svg')" alt="White Checkmark" />
                          {{ customer.translations.select_yes }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="d-flex gap-1 align-items-center">
                  <img :src="require('../images/svgs/delivery_truck_icon.svg')" alt="Delivery Truck Icon" />
                  <h4 class="m-0 arrival-text">
                    {{ customer.translations.allow_2_to_3_weeks_for_delivery_1 }}
                    {{ customer.translations.allow_2_to_3_weeks_for_delivery_2 }}.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <LogoUpload
      v-if="showLogoUpload"
      :currentStepIndex="localStepIndex"

      :currentUser="currentUser"
      :customer="customer"
      :vendor="vendor"
      :rmm="rmm"
      :image_present="image_present"

      :jerseys="jerseys"
      :variants="variants"

      :shorts="shorts"
      :shortsVariants="shortsVariants"

      :socks="socks"
      :socksVariants="socksVariants"

      :oldSocks="oldSocks"
      :oldSocksVariants="oldSocksVariants"

      :newSocks="newSocks"
      :newSocksVariants="newSocksVariants"

      :balls="balls"
      :ballsVariants="ballsVariants"

      :medals="medals"
      :medalsVariants="medalsVariants"

      :enabledSportsSite="enabledSportsSite"
      :orderImage="orderImage"

      :ageGroups="ageGroups"

      :totalJerseysOrdered="totalJerseysOrdered"
      :jerseyVariantQuantities="jerseyVariantQuantities"

      :totalShortsOrdered="totalShortsOrdered"
      :shortsVariantQuantities="shortsVariantQuantities"

      :totalSocksOrdered="totalSocksOrdered"
      :socksVariantQuantities="socksVariantQuantities"

      :totalBallsOrdered="totalBallsOrdered"
      :ballsVariantQuantities="ballsVariantQuantities"

      :totalMedalsOrdered="totalMedalsOrdered"
      :medalsVariantQuantities="medalsVariantQuantities"
    />
  </div>

  <PlaceYourOrder
    v-if="showPlaceYourOrder"
    :currentStepIndex="localStepIndex"

    :currentUser="currentUser"
    :customer="customer"
    :vendor="vendor"
    :rmm="rmm"

    :jerseys="jerseys"
    :variants="variants"

    :shorts="shorts"
    :shortsVariants="shortsVariants"

    :socks="socks"
    :socksVariants="socksVariants"

    :oldSocks="oldSocks"
    :oldSocksVariants="oldSocksVariants"

    :newSocks="newSocks"
    :newSocksVariants="newSocksVariants"

    :balls="balls"
    :ballsVariants="ballsVariants"

    :medals="medals"
    :medalsVariants="medalsVariants"

    :enabledSportsSite="enabledSportsSite"
    :orderImage="orderImage"

    :ageGroups="ageGroups"

    :totalJerseysOrdered="totalJerseysOrdered"
    :jerseyVariantQuantities="jerseyVariantQuantities"

    :totalShortsOrdered="totalShortsOrdered"
    :shortsVariantQuantities="shortsVariantQuantities"

    :totalSocksOrdered="totalSocksOrdered"
    :socksVariantQuantities="socksVariantQuantities"

    :totalBallsOrdered="totalBallsOrdered"
    :ballsVariantQuantities="ballsVariantQuantities"

    :totalMedalsOrdered="totalMedalsOrdered"
    :medalsVariantQuantities="medalsVariantQuantities"
    :image_present="image_present"
  />
</template>

<script>
  import { defineAsyncComponent } from 'vue';

  export default {
    name: 'LogoSelection',
    emits: ['selectYes', 'selectNo'],
    components: {
      PlaceYourOrder: defineAsyncComponent(() => import('./PlaceYourOrder.vue')),
      LogoUpload: defineAsyncComponent(() => import('./LogoUpload.vue'))
    },
    props: {
      currentUser: {
        type: Object,
        required: true
      },
      customer: {
        type: Object,
        required: true
      },
      vendor: {
        type: Object,
        required: true
      },
      rmm: {
        type: Object,
        required: true
      },

      jerseys: {
        type: Object,
        required: true
      },
      variants: {
        type: Object,
        required: true
      },
      shorts: {
        type: Object,
        required: true
      },
      shortsVariants: {
        type: Object,
        required: true
      },
      socks: {
        type: Object,
        required: true
      },
      socksVariants: {
        type: Object,
        required: true
      },
      oldSocks: {
        type: Array,
        default: null
      },
      oldSocksVariants: {
        type: Array,
        default: null
      },
      newSocks: {
        type: Array,
        default: null
      },
      newSocksVariants: {
        type: Array,
        default: null
      },
      balls: {
        type: Object,
        required: true
      },
      ballsVariants: {
        type: Object,
        required: true
      },
      medals: {
        type: Object,
        required: true
      },
      medalsVariants: {
        type: Object,
        required: true
      },

      notifications: {
        type: Array,
        required: true
      },
      enabledSportsSite: {
        type: String,
        required: true
      },
      orderImage: {
        type: File,
        required: false
      },
      currentStepIndex: {
        type: Number,
        default: 0,
        required: false
      },

      ageGroups: {
        type: Array,
        required: true
      },

      totalJerseysOrdered: {
        type: Number,
        required: true
      },
      jerseyVariantQuantities: {
        type: Object,
        required: true
      },

      totalShortsOrdered: {
        type: Number,
        required: true
      },
      shortsVariantQuantities: {
        type: Object,
        required: true
      },

      totalSocksOrdered: {
        type: Number,
        required: true
      },
      socksVariantQuantities: {
        type: Object,
        required: true
      },

      totalBallsOrdered: {
        type: Number,
        required: true
      },
      ballsVariantQuantities: {
        type: Object,
        required: true
      },

      totalMedalsOrdered: {
        type: Number,
        required: true
      },
      medalsVariantQuantities: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        localStepIndex: this.currentStepIndex,
        showLogoSelection: true,
        showLogoUpload: false,
        showPlaceYourOrder: false,
        image_present: null,
      };
    },
    mounted() {
      if (this.customer.program_type === 'Monetary') {
        this.showPlaceYourOrder = true;
        this.showLogoSelection = false;
        this.showLogoUpload = false;
        this.localStepIndex = 3; // Other Products Selection
      }
      // TODO Remove if not needed
      // else {
      //   this.showPlaceYourOrder = false;
      //   this.showLogoSelection = false;
      //   this.showLogoUpload = true;
      //   this.localStepIndex = 1; // LogoSelection
      // }
    },
    methods: {
      showImageViewOnly() {
        this.image_present = true;
        this.showLogoSelection = false;
        this.showLogoUpload = true;
        this.localStepIndex = 2; // LogoUpload
      },
      monetaryCustomers() {
        this.image_present = false;
        // Method logic here
        // TODO Add later if needed
      },
      showPlaceYourOrderView() {
        this.image_present = false
        this.showLogoSelection = false;
        this.showLogoUpload = false;
        this.showPlaceYourOrder = true;
        this.localStepIndex = 3; // Other Products Section
      },
      goToJerseysStep() {
        this.showLogoSelection = false;
        this.showLogoUpload = false;
        this.showPlaceYourOrder = true;
        this.localStepIndex = 0;
      }
    }
  };
</script>
